// static and auth pages

import Login from "../Pages/Auth/Login";
import Bookings from "../Pages/Static/Bookings";
import FailedTransaction from "../Pages/Static/FailedTransaction";
import Flight from "../Pages/Static/Flight";
import Landing from "../Pages/Static/Landing";
import UsersTransactions from "../Pages/Static/UsersTransactions";

export const routeObj = {
  landing: "/",
  flight: "/flight",
  login: "/sign-up",
  booking: "/flight/booking/",
  allbookings: "/bookings",
  failedBookings: "/bookings/failed",
};

export const homeRoute: routeList = [
  {
    path: routeObj.landing,
    component: Landing,
  },
  {
    path: routeObj.flight,
    component: Flight,
  },
  {
    path: routeObj.failedBookings,
    component: FailedTransaction,
  },
  {
    path: routeObj.allbookings,
    component: UsersTransactions,
  },
  {
    path: `${routeObj.booking}:id`,
    component: Bookings,
  },
];

export const authRoute: routeList = [
  {
    path: routeObj.login,
    component: Login,
  },
];

export const protectedRoute: routeList = [];

export const adminProtectedRoute: routeList = [];
